import BulletDotSVG from "../../../../../custom-ui/icons/BulletDotSVG";

type BulletTextWrapperProps = {
  children: React.ReactNode;
};

const BulletTextWrapper = ({ children }: BulletTextWrapperProps) => {
  return (
    <div className="flex items-start space-x-2">
      {/* Bullet */}
      <div className="w-[10px] h-[10px] mt-[6px] flex-shrink-0">
        <BulletDotSVG className="w-full h-full" />
      </div>

      {/* Text */}
      <div className="text-sm leading-[17.4px]">
        {typeof children === "string" ? children.trim() : children}
      </div>
    </div>
  );
};

export default BulletTextWrapper;
